/** Shared sidebar dimensions — keep in sync with AdminLayout */
export const SIDEBAR_WIDTH_EXPANDED = 248;
export const SIDEBAR_WIDTH_COLLAPSED = 76;
